export enum DisplayEnum {
  DEFAULT = 'Default',
  LIGHT = 'Light',
  DARK = 'Dark',
}
